import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { ScheduleInput } from 'generated/graphql-types';
import { forkJoin, Observable } from 'rxjs';
import {
   createScheduleInput,
   getDeletedClosedExceptionIds,
   getDeletedScheduleHourIds,
} from 'src/app/common-components/helpers/schedule-helper';
import { ClosedExceptionItemView } from '../../closed-exceptions/models/closed-exceptions.model';
import { ScheduleDetailSaveModel } from '../models/schedule-detail-save.model';
import { deleteScheduleMutation } from '../queries/delete-schedule.graphql';
import { DeleteScheduleVariables } from '../queries/generated/DeleteSchedule';
import { SaveSchedule, SaveScheduleVariables } from '../queries/generated/SaveSchedule';
import { SaveScheduleMutation } from '../queries/save-schedule.graphql';

@Injectable({ providedIn: 'root' })
export class ScheduleDetailApiService {
   constructor(private apiService: LcsApiService, private httpClient: HttpClient) {}

   save(
      scheduleDetail: ScheduleDetailSaveModel,
      fields: (keyof ScheduleInput)[]
   ): Observable<ExecutionResult<SaveSchedule>> {
      const schedule = createScheduleInput(scheduleDetail, fields);

      let deletedScheduleHourIds: number[] = [];
      deletedScheduleHourIds = getDeletedScheduleHourIds(scheduleDetail.scheduleHours ?? []);

      let deletedClosedExceptionIds: number[] = [];
      deletedClosedExceptionIds = getDeletedClosedExceptionIds(scheduleDetail.closedExceptions ?? []);

      const variables: SaveScheduleVariables = {
         deletedClosedExceptionIds,
         deletedScheduleHourIds,
         hasDeletedClosedExceptions: deletedClosedExceptionIds.length > 0,
         hasDeletedScheduleHours: deletedScheduleHourIds.length > 0,
         schedule: schedule,
      };

      return this.apiService.query<SaveSchedule, SaveScheduleVariables>({
         query: SaveScheduleMutation,
         variables: variables,
      });
   }

   deleteSchedule(scheduleId: number): Observable<ExecutionResult<void>> {
      return this.apiService.query<void, DeleteScheduleVariables>({
         query: deleteScheduleMutation,
         variables: {
            scheduleId,
         },
      });
   }

   copyClosedException(closedExceptions: ClosedExceptionItemView[]): Observable<any> {
      const copyCalls = closedExceptions.map((closedException) => {
         const closedExceptionCopyBody = {
            closedException: {
               endDate: closedException.endDate,
               endTime: closedException.endTime,
               promptId: closedException.prompt?.promptId,
               startDate: closedException.startDate,
               startTime: closedException.startTime,
            },
            scheduleIds: closedException.schedulesToCopyTo ?? [],
         };
         const httpOptions = {
            headers: new HttpHeaders({
               'Content-Type': 'application/json',
            }),
         };
         const url = this.apiService.buildApiUrl('ClosedExceptions/CopyClosedException');
         return this.httpClient.post(url, closedExceptionCopyBody, httpOptions);
      });

      return forkJoin(copyCalls);
   }
}
